import React from 'react';

const updatedOn = 'March 19, 2026';

function TermsPage() {
    return (
        <main className="min-h-screen bg-gray-50 px-4 sm:px-6 lg:px-8 py-12">
            <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 lg:p-10">
                <h1 className="text-3xl sm:text-4xl font-semibold text-gray-900 tracking-tight">Terms of Service</h1>
                <p className="mt-3 text-sm text-gray-500">Last updated: {updatedOn}</p>

                <div className="mt-8 space-y-6 text-sm sm:text-base text-gray-700 leading-relaxed">
                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">1. Acceptance of Terms</h2>
                        <p className="mt-2">
                            By using Kaeros, you agree to these Terms of Service. If you do not agree,
                            do not use the service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">2. Account Responsibilities</h2>
                        <p className="mt-2">
                            You are responsible for maintaining the confidentiality of your credentials and for all
                            activity that occurs under your account.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">3. Permitted Use</h2>
                        <p className="mt-2">
                            You agree to use the platform lawfully and in compliance with all applicable regulations,
                            including communications, privacy, and anti-spam requirements.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">4. Service Availability</h2>
                        <p className="mt-2">
                            We may modify, suspend, or discontinue features at any time to improve reliability and
                            security. We will make reasonable efforts to communicate major changes.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900">5. Contact</h2>
                        <p className="mt-2">
                            Questions about these terms can be sent through the contact channels provided in the app.
                        </p>
                    </section>
                </div>
            </div>
        </main>
    );
}

export default TermsPage;
